import type { BaseController } from '@infra/controllers/base.controller';
import type { TeammateAvailabilityChangePayload } from '@main/event-listeners/payloads/bus-agent-list.payload';
import type { TeammateAvailabilityChangedUsecase } from './teammate-availability-changed.usecase';

export type TeammateAvailabilityChangeOutput = void;

export class TeammateAvailabilityChangedController
  implements
    BaseController<
      TeammateAvailabilityChangePayload,
      TeammateAvailabilityChangeOutput
    >
{
  constructor(private usecase: TeammateAvailabilityChangedUsecase) {}

  async handle(
    payload: TeammateAvailabilityChangePayload,
  ): Promise<TeammateAvailabilityChangeOutput> {
    await this.usecase.run(payload);
  }
}
